import { required, maxLength, between, requiredIf, helpers } from 'vuelidate/lib/validators';

import packageValidation from '../validators/packageValidation';
import addressValidation from '../validators/addressValidation';
import pickupValidation from '../validators/pickupValidation';
import shipmentOptionsValidation from '../validators/shipment-optionsValidation';
import userAccountValidation from '../validators/userAccountValidation';
import customsValidation from '../validators/customsValidation';
import store from '@/store';
import conditionalAddressValidation from '../validators/conditionalAddressValidation';
import {FIELD_NAMES} from "@/store/nameConstants";


const insuranceAmountRequired = (min, max) =>
    helpers.withParams({ type: 'between', min, max }, (value) => {
        const isInsuranceRequired = store.getters['createShipment/isInsuranceRequired'];
        const isReceiverPays = store.getters['createShipment/isReceiverPays'];
        if (isInsuranceRequired && !isReceiverPays) {
            return (
                !helpers.req(value) ||
                ((!/\s/.test(value) || value instanceof Date) && +1 <= +value && +max >= +value)
            );
        }

        return (
            !helpers.req(value) ||
            ((!/\s/.test(value) || value instanceof Date) && +min <= +value && +max >= +value)
        );
    });

const InsuranceTermsAccepted = () => {
    const isInsuranceRequired = store.getters['createShipment/isInsuranceRequired'];
    const result = store.getters['createShipment/hasShipmentOptions'];
    let hasInsuranceAmount = this.shipment.insuranceAmount.amount !== 0;
    if (!isInsuranceRequired && result && hasInsuranceAmount){
        return false;
    }
    return true;
}

const senderAddressValidation = requiredIf(function() {
    return this.shipment.shipmentType === 'Export';
});

export default {
    validations: {
        shipment: {
            accountId: userAccountValidation.accountId,
            texts: packageValidation.texts,
            receiverAddress: addressValidation,
            senderAddress: {
                // Apply the requiredIf validator conditionally
                required: senderAddressValidation,
                ...addressValidation // Include other address validation rules
            },
            pickupAddress: addressValidation,
            soldToAddress: conditionalAddressValidation,
            brokerAddress: conditionalAddressValidation,
            colliDetails: packageValidation.colliDetails,
            collis: packageValidation.collis,
            receiverPays: shipmentOptionsValidation.receiverPays,
            customsAmount: customsValidation,
            shipFromBookingInitialsOnBehalfOf: {
                required: requiredIf(() => {
                    try {
                        const hasShipmentOptions = store.getters['createShipment/hasShipmentOptions'];
                        const viewOptions = store.getters['createShipment/getViewOptions'];
                        const field = viewOptions.filter((opt) => {
                            return opt.name === FIELD_NAMES.SHIP_FROM_BOOKING_INITIALS;
                        })[0];
                        return hasShipmentOptions && field.required;    
                    } catch (e) {
                        console.error(e)
                        return false;
                    }
                    
                })
            },
            shipFromBookingDepOnBehalfOf: {
                required: requiredIf(() => {
                    try {
                        const hasShipmentOptions = store.getters['createShipment/hasShipmentOptions'];
                        const viewOptions = store.getters['createShipment/getViewOptions'];
                        const field = viewOptions.filter((opt) => {
                            return opt.name === FIELD_NAMES.SHIP_FROM_BOOKING_DEP;
                        })[0];
                        return hasShipmentOptions && field.required;    
                    } catch (e) {
                        console.error(e)
                        return false;
                    }
                    
                })
            },
            shipmentAmount: {
                amount: {
                },
                currencyCode: {
                    required: requiredIf(function () {
                        const hasShipmentOptions = store.getters['createShipment/hasShipmentOptions'];
                        return (
                            this.shipment.shipmentAmount.amount !== 0 && hasShipmentOptions
                        );
                    })
                },
            },
            insuranceAmount: {
                amount: {
                    required,
                    between: insuranceAmountRequired(0, 999999999)
                },
                currencyCode: {
                    required: requiredIf(function() {
                        return (
                            this.shipment.insuranceAmount.amount !== 0 &&
                            !store.state.createShipment.insuranceAmountRequired
                        );
                    })
                },
                termsAccepted: {
                    custom: function() {
                        const isInsuranceRequired = store.getters['createShipment/isInsuranceRequired'];
                        const result = store.getters['createShipment/hasShipmentOptions'];
                        if (this) {
                            let hasInsuranceAmount = this.shipment.insuranceAmount.amount !== 0;
                            let hasAccepted = this.shipment.insuranceAmount.termsAccepted;
                            if (!isInsuranceRequired && result && hasInsuranceAmount && !hasAccepted) {
                                return false;
                            }
                        }
                        return true;
                    }
                }
            },
            dangerousGoods: packageValidation.dangerousGoods
        }
    }
};
